import { DEF_SEARCH_PARAM_VH_HISTORY } from '../components/FleetHealthV2/constants';

const defaultState = {
  searchParams: {
    ...DEF_SEARCH_PARAM_VH_HISTORY,
  },
  filter: {
    dateType: 'Yesterday',
    fromDate: '',
    toDate: '',
  },
  disableDownloadBtnsLive: true,
  disableDownloadBtnsHistory: true,
};

function vehicleHealthReducer(state = defaultState, action) {
  switch (action.type) {
    case 'API_FLTR_VH':
      return {
        ...state,
        searchParams: action.payload,
      };
    case 'UPD_API_FLTR_VH':
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
        },
      };
    case 'FLTR_UI_STATE_VH':
      return {
        ...state,
        filter: action.payload,
      };
    case 'VH_TOGGLE_DWNLD_BTN_LIVE':
      return { ...state, disableDownloadBtnsLive: action.payload };
    case 'VH_TOGGLE_DWNLD_BTN_HISTORY':
      return { ...state, disableDownloadBtnsHistory: action.payload };
    default:
      return state;
  }
}

export default vehicleHealthReducer;
